export default __webpack_public_path__ + "static/media/pulsex.df315655.svg";